import { useEffect } from 'react';

import useSharedRef from './useSharedRef';

/**
 * The skipHook argument can be used to conditionally use this hook.
 * For example if you want to scroll to an element if there is a certain hash in the url.
 *
 * ```
 * useScrollToElement(ref, false, document.location.hash === '#reacties');
 * ```
 */
const useScrollToElement = (ref, center = true, skipHook = false) => {
  const { refs } = useSharedRef();

  useEffect(() => {
    if (skipHook) {
      return;
    }

    const interval = setInterval(() => {
      if (ref && ref.current) {
        let top = ref.current.offsetTop;
        const { hub, subNavigation } = refs;

        if (hub) {
          top -= hub.offsetHeight;
        }

        if (subNavigation) {
          top -= subNavigation.offsetHeight;
        }

        setTimeout(() => {
          if (center) {
            ref.current.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
            clearInterval(interval);
          } else {
            window.scrollTo({
              top,
              behavior: 'smooth',
            });
            clearInterval(interval);
          }
        }, 200);
      }
    }, 200);
  }, [center, ref, refs, skipHook]);
};

export default useScrollToElement;
